export default build =>
    build.mutation({
        query(payload) {         
            return {
                url: '/testimonial/deleteTestimonial',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['allTestimonials'],
       
    })
